import styled from "styled-components";

export const Main = styled.main`
  overflow-y: auto;
  position: relative;
  width: 100%;
  height: 100vh;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: radial-gradient(
    circle at center,
    #202720 0%,
    #202720 30%,
    #252525 50%,
    #1c1c1c 100%
  );
`;

export const Container = styled.div`
  max-width: 1200px;
  min-width: 800px;

  padding: 50px;
  box-sizing: border-box;
`;

export const Header = styled.header`
  display: flex;
  gap: 10px;
  flex-direction: column;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 20px;
  margin-bottom: 20px;
  h1 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
  }
  p {
    color: rgba(255, 255, 255, 0.33);
    font-size: 15px;
  }
`;

export const Form = styled.form`
  border-radius: 10px;
  background: #303231ad;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  gap: 20px;
  margin: 0 auto;
`;

export const InputGroup = styled.div`
  flex-shrink: 0;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 500px;

  label {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 10px;
  }

  input,
  select {
    color: #fff;
    font-size: 15px;
    width: 100%;
    height: 45px;
    border-radius: 8px;
    border: 1px solid
      ${(props) => (props.error ? "#ff6b6b" : "rgba(255, 255, 255, 0.15)")};
    background: rgba(255, 255, 255, 0.05);
    box-sizing: border-box;
    padding: 0 15px;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #4caf50;
      box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  select {
    cursor: pointer;

    option {
      background: #303231;
      color: #fff;
    }
  }

  .email-input-group {
    display: flex;
    gap: 10px;
    width: 100%;
    button {
      width: 120px;
      height: 45px;
      background: #4caf50;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        background: #45a049;
      }
    }
  }
`;

export const CheckboxGroup = styled.div`
  max-width: 500px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 10px 0;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
    accent-color: #4caf50;
  }

  label {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;

    a {
      color: #4caf50;
      text-decoration: none;
      font-weight: 600;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const ErrorMessage = styled.div`
  color: #ff6b6b;
  font-size: 12px;
  margin-top: 4px;
`;

export const Button = styled.button`
  max-width: 500px;
  width: 100%;
  height: 45px;
  background: ${(props) =>
    props.disabled ? "rgba(255, 255, 255, 0.1)" : "#4CAF50"};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  transition: all 0.3s ease;
  margin-top: 10px;

  &:hover:not(:disabled) {
    background: #45a049;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const LoginLink = styled.div`
  text-align: center;
  margin-top: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;

  a {
    color: #4caf50;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const LoadingSpinner = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
